<template>
  <v-container v-if="instructions">
    <template v-if="step === 0">
      <InstructionsStart
        @nextStep="nextStep"
        :instructions="instructions"
        :shouldReadInstructions="shouldReadInstructions"
      />
    </template>
    <div v-if="step > 0 && step <= get(instructions, 'sections.items', []).length">
      <InstructionsSection
        :section="instructions.sections.items[step - 1]"
        @nextStep="nextStep"
        @previousStep="previousStep"
      />
    </div>
    <div v-if="step === get(instructions, 'sections.items', []).length + 1">
      <InstructionsSection :section="confirmData" @nextStep="instructionsRead" @previousStep="previousStep" />
    </div>
    <div v-if="step === get(instructions, 'sections.items', []).length + 2">
      <h1>Klart</h1>
      <p>Tack för att du bekräftade handledarinstruktionerna.</p>
      <ActionButton
        actionIcon="$sl-arrow-right"
        @click="
          $nextTick(() => {
            $router.push('/')
          })
        "
        >Startsidan</ActionButton
      >
    </div>
  </v-container>
</template>

<script>
import SugarDate from 'sugar/date'
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import MessageBox from '@/components/Common/MessageBox'
import ActionButton from '@/components/Common/ActionButton'
import InstructionsStart from '@/components/Instructions/InstructionsStart'
import InstructionsSection from '@/components/Instructions/InstructionsSection'
import get from 'lodash/get'

export default {
  name: 'InstructorInstructions',

  mixins: [],

  data: () => ({
    instructions: null,
    step: 0,
    shouldReadInstructions: true,
    confirmData: {
      header: 'Intygande',
      text: '',
      checks: 'Jag tagit del av samtliga instruktioner och intygar att jag förstår mitt ansvar som handledare'
    }
  }),

  components: {
    MessageBox,
    ActionButton,
    InstructionsStart,
    InstructionsSection
  },

  computed: {
    ...mapGetters('basic', ['systemSettings']),
    ...mapGetters('currentuser', ['currentUser', 'isCompanyUser'])
  },

  watch: {},
  created() {
    this.init()
  },

  methods: {
    get,
    ...mapActions('currentuser', ['updateCurrentUserData']),
    init() {
      API.getInstructions()
        .then(({data}) => {
          const commitedDate = data.committedAt
          const lastReadInstructions = this.currentUser.readInstructionsOn

          if (lastReadInstructions) {
            this.shouldReadInstructions = new SugarDate.Date(commitedDate).isAfter(lastReadInstructions).raw
          }
          this.instructions = data
        })
        .catch(error => {
          console.log('Error', error)
        })
    },
    nextStep() {
      this.step = this.step + 1
    },
    previousStep() {
      this.step = this.step - 1
    },
    instructionsRead() {
      API.updatePerson({data: {readInstructionsOn: new Date()}})        
        .then(response => {          
          this.updateCurrentUserData(response.data)
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log('There was an error:', error)
        })
      this.step = this.step + 1
    }
  }
}
</script>

<style scoped lang="scss"></style>
